'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { updateSearchParams, getSearchParams, removeSearchParam } from "@utils";
// import { roomTypes } from '@constants';


const RoomsFilter = ({ title, roomTypes, lang, dictionary }) => {

    const router = useRouter();
    let [selectedRooms, setSelectedRooms] = useState([]); // Store selected rooms
    
    const handleUpdateParams = (e) => {
        let newSelectedRooms = [...selectedRooms];

        // RESET AT ALL
        if (e.value == roomTypes?.[lang]?.[0].value) {
            removeSearchParam(title)
            newSelectedRooms = [e.value]
        // SELECT/DESELECT AS NORMAL
        } else {
            if (newSelectedRooms.includes(e.value)) {
                newSelectedRooms = newSelectedRooms.filter(room => room !== e.value && room !== roomTypes?.[lang]?.[0].value);
            } else {
                newSelectedRooms = newSelectedRooms.filter(room => room !== roomTypes?.[lang]?.[0].value);
                newSelectedRooms.push(e.value);

            }
        }
    
        setSelectedRooms(newSelectedRooms);
    
        // Update URL parameters
        let newPathName;
        if (newSelectedRooms.length === 0) {
            newPathName = removeSearchParam(title);
        } else {
            newPathName = updateSearchParams(title, newSelectedRooms.join(','));
        }
    
        router.push(newPathName);
        router.refresh();
    };
    
    useEffect(() => {
        const roomValue = getSearchParams('room');
        if (roomValue) {
            setSelectedRooms(roomValue.split(','));
        } else {
            setSelectedRooms(roomTypes?.[lang]?.[0]?.value)
        }
    }, []);

    return (

        <div className="w-full">
        <span className='text-sm text-secondary'>{dictionary.filter.numberOfRooms}:</span>
        <div className="w-full py-1 mt-1 flex flex-row">
            {roomTypes[lang].map((roomType, index) => (
                <label key={roomType.value} className={`w-full rounded-full border-[1px] ${selectedRooms.includes(roomType.value) || (index == 0 && selectedRooms.length === 0) ? 'bg-maincolor text-light border-third' : 'bg-light text-maincolor border-maincolor'} cursor-pointer flex items-center justify-center py-2`}>
                    <input
                        type="checkbox"
                        value={roomType.value}
                        checked={selectedRooms.includes(roomType.value)}
                        onChange={() => handleUpdateParams(roomType)}
                        className="hidden"
                    />
                    <span className={`text-sm`}>
                        {roomType.title}
                    </span>
                </label>
            ))}
        </div>
    </div>
    )
}

export default RoomsFilter